import { useEffect, useState } from 'react';

// Material-UI
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Skeleton from '@mui/material/Skeleton';

// Hooks
import useResponsive from 'hooks/useResponsive';
import useVirgoContent from 'hooks/useVirgoContent';

// Components
import BannerCarousel from './BannerCarousel';
import BannerCard from './BannerCard';

const Banners = () => {
  const { banners } = useVirgoContent();
  const isMobile = useResponsive('down', 'sm');
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  if (!isHydrated || banners?.status === 'loading') {
    return (
      <Container maxWidth="xl" sx={{ my: 2, py: { xs: 0, md: 3 } }} data-testid="banners-container">
        <Box sx={{ display: { xs: 'block', md: 'none' } }}>
          <Skeleton
            variant="rectangular"
            height={140}
            sx={{ borderRadius: '16px', mt: 2, mx: 'auto', width: `calc(100% - 32px)`, transform: 'unset' }}
            data-testid="banners-skeleton"
          />
        </Box>
        <Box sx={{ display: { xs: 'none', md: 'block' } }}>
          <Grid
            container
            wrap="nowrap"
            columnSpacing={1.8}
            sx={{ mt: { sm: 2, md: 0 } }}
            data-testid="banners-skeleton-grid"
          >
            {[1, 2, 3].map((num) => (
              <Grid item key={`skeletons-${num}`} xs={4}>
                <Skeleton
                  variant="rectangular"
                  width="100%"
                  height={200}
                  sx={{ borderRadius: '16px', transform: 'unset' }}
                  data-testid="banners-skeleton"
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
    );
  }

  if (!banners?.data || !banners?.data?.length) return null;

  return (
    <Container maxWidth="xl" disableGutters={isMobile} sx={{ my: 2 }} data-testid="banners-container">
      {isMobile ? (
        <BannerCarousel banners={banners?.data} />
      ) : (
        <Grid
          container
          wrap="nowrap"
          columnSpacing={1.8}
          sx={{ mt: { sm: 2, md: 0 } }}
          data-testid="banners-container-grid"
        >
          {banners?.data?.map((banner, i) => (
            <BannerCard testId={i} key={banner?.id} banner={banner} />
          ))}
        </Grid>
      )}
    </Container>
  );
};

export default Banners;
